import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { format } from 'date-fns';
import { catchError, from, map, of, switchMap } from 'rxjs';
import { TrackingFeature } from '..';
import { DealerApiService } from '../../api/dealer-api.service';
import { actions } from './distribution.actions';

@Injectable()
export class DistributionEffects {
    actions$ = inject(Actions);
    api = inject(DealerApiService);
    store = inject(Store);

    submitTestDriveForm$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitTestDriveForm),
            switchMap(({ payload, vehicle }) =>
                from(this.api.postTestDriveForm(payload)).pipe(
                    switchMap(() => {
                        return [
                            actions.submitDistributionFormResponse({ success: true }),
                            TrackingFeature.actions.formTestDriveSubmitTracking({
                                form: {
                                    comment: payload.message ?? '',
                                    date: payload.wishDate ? format(payload.wishDate, 'yyyy-MM-dd') : '',
                                    day: payload.wishDate ? format(payload.wishDate, 'EEEE') : '',
                                    time: payload.wishTime ?? '',
                                },
                                vehicle,
                                contact: {
                                    name: payload.name,
                                    email: payload.email,
                                    phone: payload.phoneNumber,
                                    generalMarketing: payload.privacyNotice,
                                },
                            }),
                        ];
                    }),
                    catchError(() => {
                        return of(actions.submitDistributionFormResponse({ success: false }));
                    }),
                ),
            ),
        );
    });

    submitGeneralContactForm$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitGeneralContactForm),
            switchMap(({ payload, vehicle }) =>
                from(this.api.postGeneralContactForm(payload)).pipe(
                    switchMap(() => {
                        const subtopicArr = [];
                        if (payload.callback) subtopicArr.push('callback');
                        if (payload.offerRequest) subtopicArr.push('offer inquiry');
                        if (payload.generalRequest) subtopicArr.push('general enquiry');

                        const form = {
                            comment: payload.message ?? '',
                            subtopic: subtopicArr.join(' | '),
                        };

                        return [
                            actions.submitDistributionFormResponse({ success: true }),
                            TrackingFeature.actions.formGeneralRequestSubmitTracking({
                                form,
                                vehicle,
                                contact: {
                                    name: payload.name,
                                    email: payload.email,
                                    phone: payload.phoneNumber,
                                    generalMarketing: payload.privacyNotice,
                                },
                            }),
                        ];
                    }),
                    catchError(() => {
                        return of(actions.submitDistributionFormResponse({ success: false }));
                    }),
                ),
            ),
        );
    });

    submitDistributionFormLoading$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(actions.submitTestDriveForm, actions.submitGeneralContactForm),
            map(() => {
                return actions.submitDistributionFormLoading({ loading: true });
            }),
        );
    });
}
